"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file */

/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */

const defaultTranslations = exports.defaultTranslations = {
  copy: 'Copy',
  dataLoadingError: 'There was an error during data loading. Please, try again later.',
  linkCopied: 'Link copied!'
};
const translationsNamespace = exports.translationsNamespace = 'feedback-benefit-dialog';
